@if(mediaService.deskmode()) {
<header class="header">
    <ng-container *ngTemplateOutlet="navcontent"></ng-container>
</header>
} @else {
<ng-container *ngTemplateOutlet="mobileMode"></ng-container>
}

<ng-template #mobileMode>
    <div class="headermob">
        <ng-container *ngTemplateOutlet="mobilelogo"></ng-container>

        <div class="mobilemenubtnwrapper">
            @if(partner && !partner()?.hideSearch) {
            <div class="" (click)="showsearch.set(!showsearch());">
                <!-- <img src="../../../../assets/tvg/search_dark.svg"> -->
                <svg width="17" height="17" viewBox="0 0 17 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.0056 6.99366C12.0056 5.21415 11.0364 3.59073 9.5044 2.68537C7.94113 1.78 6.03395 1.78 4.50195 2.68537C2.93869 3.59073 2.00073 5.21415 2.00073 6.99366C2.00073 8.80439 2.93869 10.4278 4.50195 11.3332C6.03395 12.2385 7.94113 12.2385 9.5044 11.3332C11.0364 10.4278 12.0056 8.80439 12.0056 6.99366ZM11.0364 12.1137C9.91084 12.9878 8.50391 13.4873 7.00318 13.4873C3.40767 13.4873 0.5 10.5839 0.5 6.99366C0.5 3.43463 3.40767 0.5 7.00318 0.5C10.5674 0.5 13.5064 3.43463 13.5064 6.99366C13.5064 8.52341 12.9748 9.92829 12.0994 11.0522L16.289 15.2044C16.5703 15.5166 16.5703 15.9849 16.289 16.2659C15.9763 16.578 15.5073 16.578 15.2259 16.2659L11.0364 12.1137Z"
                        fill="currentColor" />
                </svg>
            </div>
            }
            @if(partner()?.partnerid === defpartnerid) {
            <div class="" #trigerreisebuersearchmobile="cdkOverlayOrigin" cdkOverlayOrigin
                (click)="activeBueroSearch(true)">
                <img src="../../../../assets/tvg/ziel.svg">
            </div>
            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigerreisebuersearchmobile"
                [cdkConnectedOverlayOpen]="menureisebuerosearch()">
                <div class="menuuberunswrapper modalsearch">
                    <div class="buerosearchwrapper" ng-clickOutside (clickOutside)="closeMenuureisebuerosearch($event)">
                        <ng-container *ngTemplateOutlet="reisebuersearch"></ng-container>
                    </div>
                </div>
            </ng-template>
            } @else {
            <div class="" (click)="activeUberuns(true)"><img src="../../../../assets/tvg/help.svg" alt="help" /></div>

            }
            <div [matBadge]="(favoritesCount() > 0 || offerpackCount() > 0) ? (offerpackCount() > 0 ? offerpackCount() : 0) + (favoritesCount() > 0 ? favoritesCount() : 0) : ''"
                matBadgePosition="after" matBadgeSize="small" matBadgeColor="warn" [matMenuTriggerFor]="custmenu">
                <img src="../../../../assets/tvg/profile.svg" alt="profile" />
            </div>

            <mat-menu #custmenu="matMenu">
                @if(currentCustomer()?.email?.length > 0) {
                <button mat-menu-item (click)="logout()" aria-label="Abmelden" matRipple>
                    <mat-icon>logout</mat-icon> Abmelden
                </button>
                <button mat-menu-item (click)="gotoOfferpack()" aria-label="Abmelden" matRipple>
                    <mat-icon>local_offer</mat-icon>
                    <div [matBadge]="offerpackCount() > 0 ? offerpackCount() : ''" matBadgePosition="after"
                        matBadgeSize="small" matBadgeColor="warn">Offerpack</div>
                </button>
                } @else {
                <button mat-menu-item (click)="gotoPartner()" aria-label="Anmelden" matRipple>
                    <mat-icon>login</mat-icon> Anmelden
                </button>
                }
                <button mat-menu-item (click)="gotofavorites()" aria-label="Anmelden" matRipple>
                    <mat-icon>favorite</mat-icon>
                    <div [matBadge]="favoritesCount() > 0 ? favoritesCount() : ''" matBadgePosition="after"
                        matBadgeSize="small" matBadgeColor="warn">Favoriten</div>
                </button>
            </mat-menu>
            @if(menuactive()) {
            <div class="" (click)="closeMenu($event)"> <img src="../../../../assets/tvg/close.svg" alt="close" /></div>
            } @else {
            <div class="" (click)="openMenu($event)"><img src="../../../../assets/tvg/hambugermenu.svg"
                    alt="hambugermenu" /></div>
            }
        </div>
    </div>
    @if(showsearch() && partner && !partner()?.hideSearch) {
    <clever-headersearch></clever-headersearch>
    }
</ng-template>

<ng-template #mobilelogo>
    <div>
        <button class="logo-a-mobile" (click)="gotohome()">
            @if(logo()?.length > 0) {
            @if(isFlugb()) {
            <img class="logo-img-mobile" loading="lazy" [src]="logo()" alt="{{partner()?.firmenname}} logo">
            } @else {
            <div class="mobilelogowrapper">
                <img class="logo-img-mobile" loading="lazy" src="../../../../assets/tvg/logomobile.svg"
                    alt="{{partner()?.firmenname}} logo">
                @if(partner()?.partnerid !== defpartnerid) {
                <div class="partnerlogotextmobile" [style.color]="isFlugb() ? 'black' : '#004696'">
                    <span>{{partner()?.logotext?.length > 0 ? partner()?.logotext : partner()?.address?.city
                        }}</span>
                </div>
                }
            </div>
            }
            }
        </button>
    </div>
</ng-template>

<ng-template #navcontent>
    <div class="customheader">
        <div class="menuline">
            <div class="menuwrapper">
                <div class="customlogo" (click)="gotohome()">
                    <img [src]="logo()" alt="logo">
                    @if(partner()?.partnerid !== defpartnerid) {
                    <div class="partnerlogotext" [style.color]="isFlugb() ? 'black' : '#004696'">
                        <span>{{partner()?.logotext?.length > 0 ? partner()?.logotext : partner()?.address?.city
                            }}</span>
                    </div>
                    }
                </div>
                <div class="itemswrapper">
                    @if(partner()?.partnerid !== defpartnerid) {
                    <div class="menuitem" (click)="openMenuoffice($event)">Reisebüro</div>
                    }
                    <div class="menuitem" (click)="openMenuurlaubssuchen($event)">Urlaubssuche</div>
                    <div class="menuitem" (click)="openMenuurlaubsziele($event)">Urlaubsziele</div>
                    <!--</div>
				<div class="itemswrapper">-->
                    <div class="customsearch gray_unfilled searchinputwrapper w230px">
                        <svg class="customicon" width="25" height="25" viewBox="0 0 17 17" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M12.0056 6.99366C12.0056 5.21415 11.0364 3.59073 9.5044 2.68537C7.94113 1.78 6.03395 1.78 4.50195 2.68537C2.93869 3.59073 2.00073 5.21415 2.00073 6.99366C2.00073 8.80439 2.93869 10.4278 4.50195 11.3332C6.03395 12.2385 7.94113 12.2385 9.5044 11.3332C11.0364 10.4278 12.0056 8.80439 12.0056 6.99366ZM11.0364 12.1137C9.91084 12.9878 8.50391 13.4873 7.00318 13.4873C3.40767 13.4873 0.5 10.5839 0.5 6.99366C0.5 3.43463 3.40767 0.5 7.00318 0.5C10.5674 0.5 13.5064 3.43463 13.5064 6.99366C13.5064 8.52341 12.9748 9.92829 12.0994 11.0522L16.289 15.2044C16.5703 15.5166 16.5703 15.9849 16.289 16.2659C15.9763 16.578 15.5073 16.578 15.2259 16.2659L11.0364 12.1137Z"
                                fill="currentColor" />
                        </svg>
                        <!-- <input type="text" class="searchinput" placeholder=""> -->
                        <clever-headersearch style="width: calc(100% - 25px);"></clever-headersearch>
                    </div>
                    @if(partner()?.partnerid === defpartnerid) {
                    <button class="custombutton gray_unfilled positionrel" #trigerreisebuersearch="cdkOverlayOrigin"
                        cdkOverlayOrigin (click)="activeBueroSearch(true)">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17.7273 20.2143H13.793C14.4539 19.6181 15.0771 18.9807 15.6591 18.3058C17.8426 15.7689 19 13.0946 19 10.5714C19 8.69597 18.2625 6.89732 16.9497 5.57117C15.637 4.24502 13.8565 3.5 12 3.5C10.1435 3.5 8.36301 4.24502 7.05025 5.57117C5.7375 6.89732 5 8.69597 5 10.5714C5 13.0946 6.1542 15.7689 8.34091 18.3058C8.92287 18.9807 9.54614 19.6181 10.207 20.2143H6.27273C6.10395 20.2143 5.94209 20.282 5.82275 20.4026C5.70341 20.5231 5.63636 20.6866 5.63636 20.8571C5.63636 21.0276 5.70341 21.1912 5.82275 21.3117C5.94209 21.4323 6.10395 21.5 6.27273 21.5H17.7273C17.896 21.5 18.0579 21.4323 18.1772 21.3117C18.2966 21.1912 18.3636 21.0276 18.3636 20.8571C18.3636 20.6866 18.2966 20.5231 18.1772 20.4026C18.0579 20.282 17.896 20.2143 17.7273 20.2143ZM6.27273 10.5714C6.27273 9.03696 6.87613 7.56534 7.95021 6.48031C9.02428 5.39528 10.481 4.78571 12 4.78571C13.519 4.78571 14.9757 5.39528 16.0498 6.48031C17.1239 7.56534 17.7273 9.03696 17.7273 10.5714C17.7273 15.1703 13.3149 19.0089 12 20.0536C10.6851 19.0089 6.27273 15.1703 6.27273 10.5714ZM15.1818 10.5714C15.1818 9.9357 14.9952 9.31425 14.6456 8.78567C14.296 8.25708 13.799 7.8451 13.2176 7.60182C12.6362 7.35853 11.9965 7.29488 11.3793 7.4189C10.762 7.54293 10.1951 7.84906 9.75011 8.29859C9.30513 8.74811 9.00209 9.32084 8.87932 9.94435C8.75655 10.5679 8.81956 11.2141 9.06038 11.8015C9.30121 12.3888 9.70903 12.8908 10.2323 13.244C10.7555 13.5972 11.3707 13.7857 12 13.7857C12.8439 13.7857 13.6532 13.4471 14.2499 12.8443C14.8466 12.2415 15.1818 11.4239 15.1818 10.5714ZM10.0909 10.5714C10.0909 10.19 10.2029 9.81712 10.4126 9.49997C10.6224 9.18282 10.9206 8.93563 11.2694 8.78966C11.6183 8.64369 12.0021 8.6055 12.3724 8.67991C12.7428 8.75433 13.0829 8.93801 13.3499 9.20772C13.6169 9.47744 13.7987 9.82108 13.8724 10.1952C13.9461 10.5693 13.9083 10.9571 13.7638 11.3095C13.6193 11.6619 13.3746 11.9631 13.0606 12.175C12.7467 12.3869 12.3776 12.5 12 12.5C11.4937 12.5 11.0081 12.2968 10.6501 11.9351C10.292 11.5735 10.0909 11.0829 10.0909 10.5714Z" />
                        </svg>

                        <span>Reisebüro finden</span>
                    </button>
                    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigerreisebuersearch"
                        [cdkConnectedOverlayOpen]="menureisebuerosearch()" [cdkConnectedOverlayPositions]="overlaypos">
                        <div class="menuuberunswrapper modalsearch">
                            <div class="buerosearchwrapper" ng-clickOutside
                                (clickOutside)="closeMenuureisebuerosearch($event)">
                                <ng-container *ngTemplateOutlet="reisebuersearch"></ng-container>
                            </div>
                        </div>
                    </ng-template>
                    } @else {
                    <button class="custombutton gray_unfilled" (click)="activeUberuns(true)">

                        <svg width="20" height="16" viewBox="0 0 20 16" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.5 2.24268V7.74268C1.5 8.18018 1.8125 8.49268 2.25 8.49268H3.75C4.15625 8.49268 4.5 8.83643 4.5 9.24268V9.86768L6.3125 8.61768C6.4375 8.55518 6.59375 8.49268 6.75 8.49268H10.75C11.1562 8.49268 11.5 8.18018 11.5 7.74268V2.24268C11.5 1.83643 11.1562 1.49268 10.75 1.49268H2.25C1.8125 1.49268 1.5 1.83643 1.5 2.24268ZM2.25 -0.00732422H10.75C11.9688 -0.00732422 13 1.02393 13 2.24268V7.74268C13 8.99268 11.9688 9.99268 10.75 9.99268H6.96875L4.15625 11.8677C3.9375 12.0239 3.625 12.0552 3.375 11.9302C3.125 11.7739 3 11.5239 3 11.2427V9.99268H2.25C1 9.99268 0 8.99268 0 7.74268V2.24268C0 1.02393 1 -0.00732422 2.25 -0.00732422ZM8 11.7427V10.9927H9.5V11.7427C9.5 12.1802 9.8125 12.4927 10.25 12.4927H13.25C13.375 12.4927 13.5312 12.5552 13.6562 12.6177L15.5 13.8677V13.2427C15.5 12.8364 15.8125 12.4927 16.25 12.4927H17.75C18.1562 12.4927 18.5 12.1802 18.5 11.7427V6.24268C18.5 5.83643 18.1562 5.49268 17.75 5.49268H14V3.99268H17.75C18.9688 3.99268 20 5.02393 20 6.24268V11.7427C20 12.9927 18.9688 13.9927 17.75 13.9927H17V15.2427C17 15.5239 16.8438 15.7739 16.5938 15.9302C16.3438 16.0552 16.0625 16.0239 15.8125 15.8677L13 13.9927H10.25C9 13.9927 8 12.9927 8 11.7427Z"
                                fill="currentColor" />
                        </svg>

                        <span>Hilfe & Kontakt</span>
                    </button>
                    }

                    <div class="iconbutton"
                        [matBadge]="(favoritesCount() > 0 || offerpackCount() > 0) ? (offerpackCount() > 0 ? offerpackCount() : 0) + (favoritesCount() > 0 ? favoritesCount() : 0) : ''"
                        matBadgePosition="after" matBadgeSize="small" matBadgeColor="warn"
                        [matMenuTriggerFor]="custmenu">
                        <img src="../../../../assets/tvg/profile.svg" alt="profile" />
                    </div>

                    <mat-menu #custmenu="matMenu">
                        @if(currentCustomer()?.email?.length > 0) {
                        <button mat-menu-item (click)="logout()" aria-label="Abmelden" matRipple>
                            <mat-icon>logout</mat-icon> Abmelden
                        </button>
                        <button mat-menu-item (click)="gotoOfferpack()" aria-label="Abmelden" matRipple>
                            <mat-icon>local_offer</mat-icon>
                            <div [matBadge]="offerpackCount() > 0 ? offerpackCount() : ''" matBadgePosition="after"
                                matBadgeSize="small" matBadgeColor="warn">Offerpack</div>
                        </button>
                        } @else {
                        <button mat-menu-item (click)="gotoPartner()" aria-label="Anmelden" matRipple>
                            <mat-icon>login</mat-icon> Anmelden
                        </button>
                        }
                        <button mat-menu-item (click)="gotofavorites()" aria-label="Anmelden" matRipple>
                            <mat-icon>favorite</mat-icon>
                            <div [matBadge]="favoritesCount() > 0 ? favoritesCount() : ''" matBadgePosition="after"
                                matBadgeSize="small" matBadgeColor="warn">Favoriten</div>
                        </button>
                    </mat-menu>
                    <div class="iconbutton" (click)="openMenu($event)"><img
                            src="../../../../assets/tvg/hambugermenu.svg" alt="hambugermenu" /></div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- <ng-template #subnavcontent>
    <div class="submenuwrapper">
        <a class="afon" href="tel:{{partner()?.tel}}" (mouseover)="fixsetoultip.set(true)"
            (mouseleave)="fixsetoultip.set(false)" #trigertooltip="cdkOverlayOrigin" cdkOverlayOrigin>
            <span>{{partner()?.tel}}</span>
        </a>
        @if(!partner()?.hideTermin) {
        <button class="headerbtn" matTooltip="Termin" aria-label="Termin" (click)="gotoCalendar()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z" />
            </svg>
        </button>
        }
        @if(!partner()?.hideChat) {
        <button class="headerbtn" matTooltip="Chat" aria-label="Chat" (click)="openChat()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" />
            </svg>
        </button>
        }
        @if(partner && !partner()?.hideLogin) {
        @if(currentCustomer()?.email?.length > 0) {

        <button [matMenuTriggerFor]="custmenu" [matTooltip]="currentCustomer()?.firstname ? currentCustomer().firstname + ' ' + currentCustomer().lastname :
                            'Mein Konto'" class="headerbtn" matRipple>
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24"
                width="24px" fill="currentColor">
                <g>
                    <rect fill="none" height="24" width="24" />
                </g>
                <g>
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z" />
                </g>
            </svg>
        </button>
        <mat-menu #custmenu="matMenu">
            <button mat-menu-item (click)="logout()" aria-label="Logout" matRipple>
                <mat-icon>exit_to_app</mat-icon> Logout
            </button>
        </mat-menu>
        }@else {
        <ng-container *ngTemplateOutlet="anmelden"></ng-container>
        }
        <ng-template #anmelden>
            <button class="headerbtn" matTooltip="Anmelden" aria-label="Anmelden" (click)="gotoPartner()">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
            </button>
        </ng-template>
        }

        @if(partner()?.multilangualktiv) {
        <button [matMenuTriggerFor]="langmenu" aria-label="menu" class="cc8" matRipple>
            <span>{{i18nService.langUp}}</span>
        </button>
        <mat-menu #langmenu="matMenu">
            <button mat-menu-item (click)="changeLng('de')" aria-label="de" matRipple>
                DE
            </button>
            <button mat-menu-item (click)="changeLng('fr')" aria-label="fr" matRipple>
                FR
            </button>
            <button mat-menu-item (click)="changeLng('nl')" aria-label="nl" matRipple>
                NL
            </button>
        </mat-menu>
        }

    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigertooltip"
        [cdkConnectedOverlayOpen]="fixsetoultip()">
        <div class="cc17 mat-elevation-z1">
            <div class="cc19">
                <b>{{partner()?.tel}}</b><br>
                @if(partner()?.opening_period?.length > 0) {
                <span class="mt1 cc20">{{partner()?.opening_period}}</span>
                } @else {
                <span>Beratung & Buchung täglich von</span><br>
                }
            </div>
        </div>
    </ng-template>
</ng-template> -->


@if(openUberuns()) {
<div class="menuuberunswrapper">
    <div class="mainmenucontainer" [style.justify-content]="mediaService.deskmode() ? 'space-around' : 'unset'"
        [style.flex-direction]="mediaService.deskmode() ? 'row' : 'column'"
        [style.gap]="mediaService.deskmode() ? '24px' : '0px'"
        [style.padding]="mediaService.deskmode() ? '0px' : '16px'"
        [style.overflow]="mediaService.deskmode() ? 'unset' : 'auto'" ng-clickOutside
        (clickOutside)="activeUberuns(false)">
        <div class="teamcontainer">
            <img [src]="partner()?.teamimage">
            <button class="blue custombutton" (click)="gototeam()">Unser Team</button>
        </div>
        <div class="contactwrapcontainer">
            <div class="address">
                <h3>{{partner()?.firmenname}}</h3>
                <!-- <h3>{{partner()?.address?.city}}</h3> -->
                <p>{{partner()?.address?.street}} {{partner()?.address?.street2}}</p>
                <p>{{partner()?.address?.city}}</p>
            </div>
            <div class="contactdatacontainer">
                <p><a href="tel:{{partner().tel}}">Telefon: {{partner()?.tel}}</a></p>
                @if(partner()?.mobileaswhatsapp || partner()?.telaswhatsapp) {
                <p><a [href]="(partner()?.mobileaswhatsapp ? 'https://api.whatsapp.com/send/?phone=' + partner()?.mobile?.replaceAll('+', '')?.replaceAll('(', '')?.replaceAll(' ', '')?.replaceAll(')', '') + '&text&type=phone_number&app_absent=0' : 'https://api.whatsapp.com/send/?phone=' + partner()?.tel?.replaceAll('+', '')?.replaceAll('(', '')?.replaceAll(' ', '')?.replaceAll(')', '') + '&text&type=phone_number&app_absent=0')"
                        target="_blank">WhatsApp: {{partner()?.mobileaswhatsapp ? partner()?.mobile :
                        partner()?.tel}}</a></p>
                }
                <p> <a href="mailto:{{partner().email}}">Mail: {{partner()?.email}}</a></p>
                @if(!partner()?.hideTermin) {
                <p><a (click)="gotoCalendar()">Terminvereinbarung</a></p>
                }
            </div>
        </div>
        <div class="timecontainer" [style.align-items]="mediaService.deskmode() ? 'end' : 'unset'">
            <b>Öffnungszeiten</b>
            <div class="times" [style.align-self]="mediaService.deskmode() ? 'flex-end' : 'flex-start'">
                @if(partner()?.workdays?.day1?.length > 0) {
                <ng-container
                    *ngTemplateOutlet="days; context: {name: 'Mo', array: partner()?.workdays?.day1}"></ng-container>
                }
                @if(partner()?.workdays?.day2?.length > 0) {
                <ng-container
                    *ngTemplateOutlet="days context: {name: 'Di', array: partner()?.workdays?.day2}"></ng-container>
                }
                @if(partner()?.workdays?.day3?.length > 0) {
                <ng-container
                    *ngTemplateOutlet="days context: {name: 'Mi', array: partner()?.workdays?.day3}"></ng-container>
                }
                @if(partner()?.workdays?.day4?.length > 0) {
                <ng-container
                    *ngTemplateOutlet="days context: {name: 'Do', array: partner()?.workdays?.day4}"></ng-container>
                }
                @if(partner()?.workdays?.day5?.length > 0) {
                <ng-container
                    *ngTemplateOutlet="days context: {name: 'Fr', array: partner()?.workdays?.day5}"></ng-container>
                }
                @if(partner()?.workdays?.day6?.length > 0) {
                <ng-container
                    *ngTemplateOutlet="days context: {name: 'Sa', array: partner()?.workdays?.day6}"></ng-container>
                }
                @if(partner()?.workdays?.day7?.length > 0) {
                <ng-container
                    *ngTemplateOutlet="days context: {name: 'So', array: partner()?.workdays?.day7}"></ng-container>
                }
            </div>
            @if(partner()?.workdaysextratext?.length > 0) {
            <div class="outofoffice">
                <p>{{partner().workdaysextratext}}</p>
            </div>
            }
        </div>
        <div class="rateuscontainer">
            <div class="googlerates"></div>
            <button class="rateoffice gray_unfilled custombutton" (click)="gotobwurl()">Reisebüro bewerten</button>
            <button class="rateoffice gray_unfilled custombutton" [matMenuTriggerFor]="menu">Reisebüro
                empfehlen</button>


            <mat-menu #menu="matMenu">
                <button class="icobtn" (click)="linkCopy()">
                    <img class="lazyload icow" data-src="../../../assets/social/link.svg" matTooltip="Link kopieren"
                        alt="Link kopieren">
                    <span>Link kopieren</span>
                </button>
                <button class="icobtn" (click)="shareEmail()">
                    <img class="lazyload icow" data-src="../../../assets/social/email.svg" matTooltip="Email"
                        alt="Email">
                    <span>Email</span>
                </button>
                <button class="icobtn" (click)="shareFacebook()">
                    <img class="lazyload icow" data-src="../../../assets/social/facebook.svg" matTooltip="Facebook"
                        alt="Facebook">
                    <span>Facebook</span>
                </button>
                <button class="icobtn" (click)="shareWhatsApp()">
                    <img class="lazyload icow" data-src="../../../assets/social/whatsapp.svg" matTooltip="Whatsapp"
                        alt="Whatsapp">
                    <span>WhatsApp</span>
                </button>
            </mat-menu>
        </div>
        <div class="closecross" (click)="activeUberuns(false)">x</div>
    </div>
</div>
}

@if(menuactive()) {
<div class="menuuberunswrapper">
    <div class="mainmenucontainer" ng-clickOutside (clickOutside)="closeMenu($event)">
        @if(mediaService.deskmode()) {
        <div class="dflx">
            <clever-menu2 [menutype]="'5'"></clever-menu2>
        </div>
        <div class="closecross" (click)="closeMenu($event)">x</div>
        } @else {
        <div class="dflxmobile">
            <clever-menu2 class="w100"></clever-menu2>
        </div>
        }
    </div>
</div>
}


@if(menuactiveurlaubssuche()) {
<div class="menuuberunswrapper">
    <div class="mainmenucontainer" ng-clickOutside (clickOutside)="closeMenuurlaubssuchen($event)">
        @if(mediaService.deskmode()) {
        <div class="dflx">
            <clever-menu2 [menutype]="'2'"></clever-menu2>
        </div>
        <div class="closecross" (click)="closeMenuurlaubssuchen($event)">x</div>
        }
    </div>
</div>
}

@if(menuactiveurlaubsziele()) {
<div class="menuuberunswrapper">
    <div class="mainmenucontainer" ng-clickOutside (clickOutside)="closeMenuurlaubsziele($event)">
        @if(mediaService.deskmode()) {
        <div class="dflx">
            <clever-menu2 [menutype]="'3'"></clever-menu2>
        </div>
        <div class="closecross" (click)="closeMenuurlaubsziele($event)">x</div>
        }
    </div>
</div>
}

@if(menuactiveoffice()) {
<div class="menuuberunswrapper">
    <div class="mainmenucontainer" ng-clickOutside (clickOutside)="closeMenuoffice($event)">
        @if(mediaService.deskmode()) {
        <div class="dflx">
            <clever-menu2 [menutype]="'1'"></clever-menu2>
        </div>
        <div class="closecross" (click)="closeMenuoffice($event)">x</div>
        }
    </div>
</div>
}

<ng-template #days let-name="name" let-array="array">
    <div class="timeitem">
        <span class="timeitemname">{{name}}</span>
        <div class="timegroup">
            @for (item of array; track $index) {
            @if(!item.blocked) {
            <span>
                {{item.from + '-' + item.to}}
            </span>
            }
            }
        </div>
    </div>
</ng-template>
<!-- <ng-template #overlaymenu>
</ng-template> -->

<ng-template #reisebuersearch>
    <h4>Wie wollen Sie suchen?</h4>
    <div class="buerosearchitemwrapper">
        <mat-form-field (click)="currentsearchparam.set('ort'); $event.stopPropagation();">
            <mat-label>bitte Ort wählen</mat-label>
            <select matNativeControl [(ngModel)]="ort">
                <option value="" selected></option>
                @for (ct of citys(); track $index) {
                <option [value]="ct._id">{{ct._id}}</option>
                }
            </select>
            <mat-icon matSuffix>{{currentsearchparam() === 'ort' ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
        </mat-form-field>
        <mat-form-field (click)="currentsearchparam.set('plz')">
            <mat-label>PLZ</mat-label>
            <input matInput placeholder="PLZ" [(ngModel)]="plz">
            <mat-icon matSuffix>{{currentsearchparam() === 'plz' ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
        </mat-form-field>

        <button class="custombuttonblue" (click)="gotobuerofinden()">Jetzt Reisebüro finden</button>
    </div>

    <div class="resiebueroneclicksearchwrapper">
        <span class="txt">oder per 1-Click-Lösung <br>
            mit dem Standort Ihres Browsers suchen</span>

        <button class="custombuttonblue" (click)="currentsearchparam.set('standort'); gotobuerofinden()">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.7273 20.2143H13.793C14.4539 19.6181 15.0771 18.9807 15.6591 18.3058C17.8426 15.7689 19 13.0946 19 10.5714C19 8.69597 18.2625 6.89732 16.9497 5.57117C15.637 4.24502 13.8565 3.5 12 3.5C10.1435 3.5 8.36301 4.24502 7.05025 5.57117C5.7375 6.89732 5 8.69597 5 10.5714C5 13.0946 6.1542 15.7689 8.34091 18.3058C8.92287 18.9807 9.54614 19.6181 10.207 20.2143H6.27273C6.10395 20.2143 5.94209 20.282 5.82275 20.4026C5.70341 20.5231 5.63636 20.6866 5.63636 20.8571C5.63636 21.0276 5.70341 21.1912 5.82275 21.3117C5.94209 21.4323 6.10395 21.5 6.27273 21.5H17.7273C17.896 21.5 18.0579 21.4323 18.1772 21.3117C18.2966 21.1912 18.3636 21.0276 18.3636 20.8571C18.3636 20.6866 18.2966 20.5231 18.1772 20.4026C18.0579 20.282 17.896 20.2143 17.7273 20.2143ZM6.27273 10.5714C6.27273 9.03696 6.87613 7.56534 7.95021 6.48031C9.02428 5.39528 10.481 4.78571 12 4.78571C13.519 4.78571 14.9757 5.39528 16.0498 6.48031C17.1239 7.56534 17.7273 9.03696 17.7273 10.5714C17.7273 15.1703 13.3149 19.0089 12 20.0536C10.6851 19.0089 6.27273 15.1703 6.27273 10.5714ZM15.1818 10.5714C15.1818 9.9357 14.9952 9.31425 14.6456 8.78567C14.296 8.25708 13.799 7.8451 13.2176 7.60182C12.6362 7.35853 11.9965 7.29488 11.3793 7.4189C10.762 7.54293 10.1951 7.84906 9.75011 8.29859C9.30513 8.74811 9.00209 9.32084 8.87932 9.94435C8.75655 10.5679 8.81956 11.2141 9.06038 11.8015C9.30121 12.3888 9.70903 12.8908 10.2323 13.244C10.7555 13.5972 11.3707 13.7857 12 13.7857C12.8439 13.7857 13.6532 13.4471 14.2499 12.8443C14.8466 12.2415 15.1818 11.4239 15.1818 10.5714ZM10.0909 10.5714C10.0909 10.19 10.2029 9.81712 10.4126 9.49997C10.6224 9.18282 10.9206 8.93563 11.2694 8.78966C11.6183 8.64369 12.0021 8.6055 12.3724 8.67991C12.7428 8.75433 13.0829 8.93801 13.3499 9.20772C13.6169 9.47744 13.7987 9.82108 13.8724 10.1952C13.9461 10.5693 13.9083 10.9571 13.7638 11.3095C13.6193 11.6619 13.3746 11.9631 13.0606 12.175C12.7467 12.3869 12.3776 12.5 12 12.5C11.4937 12.5 11.0081 12.2968 10.6501 11.9351C10.292 11.5735 10.0909 11.0829 10.0909 10.5714Z"
                    fill="currentColor" />
            </svg>

            <span>Suche nach Standort</span>
        </button>
    </div>

    <button (click)="closeMenuureisebuerosearch($event)" class="buerosearchclosebtn">X</button>
</ng-template>
